module.exports = __webpack_public_path__ + "static/media/fly0181.58f1b96f.webp";